
const parseConfirmationData = (data, id) => {
  if (!data || !id) return {};

  const {
    person_address_street,
    person_address_number,
    person_address_zipcode,
    person_address_floor,
    person_address_departament,
    person_address_province,
    person_phone,
    person_mail
  } = data;

  return {
    person_address_street,
    person_address_number,
    person_address_zipcode,
    person_address_floor,
    person_address_departament,
    person_address_province,
    person_phone,
    person_mail,
    id: id
  }
};

export default parseConfirmationData;
